import dpv from './dpv';
import lots from './lots';

export default {
  namespaced: true,
  state: {},
  modules: {
    dpv,
    lots
  }
}
